
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'TextLink',

  props: {
    text: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    },
    blank: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    hasArrow: {
      type: Boolean,
      default: true
    },
    iconTarget: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const classObject = computed(() => {
      return {
        textLink: true,
        'textLink-small': props.small,
        '-noArrow': !props.hasArrow,
        '-target': props.iconTarget
      }
    })

    return {
      classObject
    }
  }
})
